import { getBackendUrl } from "../config";

export async function streamOnboardingChat({
  route,
  messages,
  onDelta,
  onDone,
  onError,
}) {
  let token;
  try {
    token = JSON.parse(localStorage.getItem("token"));
  } catch (e) {
    token = null;
  }

  let resp;
  try {
    resp = await fetch(`${getBackendUrl()}/onboarding-assistant/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ route, messages }),
    });
  } catch (e) {
    onError && onError();
    return;
  }

  if (!resp.ok || !resp.body) {
    onError && onError();
    return;
  }

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    const parts = buffer.split("\n\n");
    buffer = parts.pop();

    for (const part of parts) {
      const line = part.replace(/^data: /, "").trim();
      if (!line) continue;
      try {
        const evt = JSON.parse(line);
        if (evt.text) onDelta && onDelta(evt.text);
        else if (evt.done) {
          onDone && onDone();
          return;
        } else if (evt.error) {
          onError && onError();
          return;
        }
      } catch (e) {
        // ignora fragmentos incompletos
      }
    }
  }
  onDone && onDone();
}
